<button class="d-flex flex-column" (click)="openDialog(searchBar)">
    <i class="fa fa-search cursor-pointer"></i>
    <span class="icon-text d-lg-none" translate>Search</span>
</button>
<ng-template #searchBar>
    <div class="d-flex m-auto flex-row-reverse" style="max-width: 25rem">
        <search class="flex-fill" (searchBtnClicked)="closeDialog(searchBar)"></search>
        <button (click)="closeDialog(searchBar)">
            <mat-icon class="material-icons mat-icon-rtl-mirror align-middle">arrow_back</mat-icon>
            <span class="cdk-visually-hidden" translate>Step out of search bar zone</span>
        </button>
    </div>
</ng-template>